/**
 * An object containing properties for wizard events
 */
var WizardEvent = /** @class */ (function () {
    function WizardEvent() {
    }
    return WizardEvent;
}());
export { WizardEvent };
//# sourceMappingURL=wizard-event.js.map